// extracted by mini-css-extract-plugin
export default {"tooltip":"wV-z","arrow":"xV-z"};